import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
    DateAdapter,
    MatNativeDateModule,
    MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconBasicTickModule,
    TgInputModule,
    TgSelectModule,
    TgSvgModule
} from '@trademe/tangram';
import { TmDateCustomAdapter } from './tm-date/tm-date-adapter';
import { TmDateComponent } from './tm-date/tm-date.component';
import { TmHeaderComponent } from './tm-header/tm-header.component';
import { TmIconTogglerComponent } from './tm-icon-toggler/tm-icon-toggler.component';
import { TmPageNotFoundIllustrationModule } from './tm-page-not-found-illustration/tm-page-not-found-illustration.module';
import { TmPageNotFoundComponent } from './tm-page-not-found/tm-page-not-found.component';

@NgModule({
    imports: [
        CommonModule,
        TgIconBasicArrowRightModule,
        TgIconBasicTickModule,
        TgInputModule,
        TgGridModule,
        TgSelectModule,
        TgInputModule,
        TgSvgModule,
        MatDatepickerModule,
        MatNativeDateModule,
        TmPageNotFoundIllustrationModule
    ],
    declarations: [
        TmHeaderComponent,
        TmIconTogglerComponent,
        TmDateComponent,
        TmPageNotFoundComponent
    ],
    exports: [
        TmHeaderComponent,
        TmIconTogglerComponent,
        TmDateComponent,
        TmPageNotFoundComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: DateAdapter, useClass: TmDateCustomAdapter },
        NgForm,
        MatDatepickerModule
    ]
})
export class TrademeCoreUiModule {}
